<template>
  <StoreLocatorConfigSection :title="$t('message.storeLocator.reviews.title')">
    <div class="sl-reviews">
      <div class="sl-reviews__description">
        {{ $t("message.storeLocator.reviews.description") }}
      </div>
      <div class="sl-reviews__ratings">
        <div class="sl-reviews__ratings-label">
          {{ $t("message.storeLocator.reviews.selectRatings") }}:
        </div>
        <div class="d-flex">
          <div class="flex-fill">
            <div
              class="sl-reviews__ratings-item"
              v-for="rating in [5, 4, 3, 2, 1]"
              :key="rating"
            >
              <v-checkbox
                v-model="activeRatings[rating]"
                hide-details
                @click="onChange"
              >
                <template #label>
                  <StarsRating class="ml-2" :rating="rating" :size="20" />
                </template>
              </v-checkbox>
            </div>
          </div>
          <div class="flex-fill">
            <v-checkbox
              class="sl-reviews__checkbox"
              :input-value="onlyWithText"
              :label="$t('message.storeLocator.reviews.onlyWithText')"
              hide-details
              @change="$emit('update:only-with-text', $event)"
            />
          </div>
        </div>
      </div>
    </div>
  </StoreLocatorConfigSection>
</template>

<script>
import StoreLocatorConfigSection from "@/components/StoreLocator/StoreLocatorConfigSection";
import StarsRating from "@/components/ui/StarsRating";

const defaultValue = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: false
};
export default {
  name: "StoreLocatorConfigReviews",
  components: {
    StoreLocatorConfigSection,
    StarsRating
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    onlyWithText: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    activeRatings: { ...defaultValue }
  }),
  watch: {
    value: {
      handler() {
        this.setRatings();
      },
      deep: true
    }
  },
  mounted() {
    this.setRatings();
  },
  methods: {
    setRatings() {
      this.activeRatings = { ...defaultValue };
      this.value.forEach(rating => {
        this.activeRatings[rating] = true;
      });
    },

    onChange() {
      let values = [];
      Object.keys(this.activeRatings).forEach(rating => {
        if (this.activeRatings[rating]) {
          values.push(rating);
        }
      });

      this.$emit("change", values);
    }
  }
};
</script>

<style lang="scss" scoped>
.sl-reviews {
  margin-bottom: $spacing * 3;

  &__description {
    @include font-size(14px);
    line-height: 17px;
    font-weight: 500;
    color: rgba($dark-blue-3, 0.9);
    margin-bottom: $spacing * 3;
  }

  &__ratings-label {
    @include font-size(12px);
    line-height: 17px;
    font-weight: normal;
    color: rgba($dark-blue-3, 0.6);
  }

  &__ratings-item {
    display: flex;
    align-items: center;
    margin: $spacing * 3 0;

    .v-input--checkbox {
      margin-top: 0;
      padding-top: 0;
    }
  }

  &__checkbox {
    ::v-deep .v-label {
      @include font-size(14px);
      line-height: 17px;
      color: rgba($dark-blue-3, 0.9);
      margin-left: $spacing;
    }
  }
}
</style>
